module.exports = __webpack_public_path__ + "static/media/MyHavenLogo.1f0a836f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/MyHavenLogo.png
// module id = 97
// module chunks = 0